import { OneTimeTokenDialog } from "@/components/OneTimeTokenDialog";
import type { AdminInviteIssue } from "@/types";

// #343 (UC-9): die Einladung des Erst-Admins — GENAU EINMAL sichtbar (das Portal speichert nur den versiegelten
// Blob). Mit Host zeigt der Dialog den fertigen Link, ohne Host das Token (E-Mail steht daneben, der Link ist dann
// https://<host>/ui/einladung?email=…&token=… von Hand). Weitergabe an den Kunden-Admin = menschlicher Schritt.
export function AdminInviteDialog({ invite, onClose }: { invite: AdminInviteIssue | null; onClose: () => void }) {
  if (!invite) return null;
  const value = invite.url ?? invite.token;
  return (
    <OneTimeTokenDialog
      open
      onOpenChange={(o) => !o && onClose()}
      title={`Einladung für ${invite.email}`}
      description={
        invite.url ? (
          <span>Diesen Link dem Kunden-Admin geben. Er setzt damit sein eigenes Passwort — 24 Stunden gültig ab dem Ausrollen, einmal einlösbar. Danach ist er nirgends mehr abrufbar; „Einladung erneuern“ erzeugt einen neuen.</span>
        ) : (
          <span>Die Umgebung hat keinen Host — Token und E-Mail ({invite.email}) von Hand weitergeben; der Link lautet <code className="font-mono text-xs">https://&lt;host&gt;/ui/einladung?email=…&amp;token=…</code>. Einmal einlösbar.</span>
        )
      }
      label={invite.url ? "Einladungs-Link" : "Einladungs-Token"}
      token={value}
    />
  );
}
